import React, { useState } from 'react';

const AudioPlayer = ({ src, onReset }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const modifiedUrl = src.replace("https://tecom.pro", "http://hustmedia.duckdns.org");
  let audioRef = null;
  const handleResetClick = () => {
    // Xử lý reset ở component con
    onReset(); // Gọi callback function để thông báo cho component cha
  };
  const togglePlay = () => {
    if (isPlaying) {
      audioRef.pause();
    } else {
      audioRef.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handlePlay = () => {
    setIsPlaying(true);
  };

  const handleEnded = () => {
    setIsPlaying(false);
  };
  const download = () => {
    window.open(src, '_blank');
  };
  return (
    <>
      <div>
        <button
          onClick={togglePlay}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          {isPlaying ? 'Pause' : 'Play'}
        </button>
        <button
          onClick={handleResetClick}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Reset
        </button>
        <a href={modifiedUrl} target="_blank" >
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Tải
          </button>
        </a>
      </div>

      <audio controls ref={ref => (audioRef = ref)} onPlay={handlePlay}
        onEnded={handleEnded}>
        <source src={src} />
      </audio>

    </>
  );
};

export default AudioPlayer;
